module.exports = __webpack_public_path__ + "static/media/SDD.23b261f5.pdf";